import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { Section } from './Shared';
const fitReasons = ['Keep a consultation structure and reflection prompts close at hand', 'Study traditional formula examples in a consistent format', 'Review fictional case examples without treating them as diagnoses', 'Have printable records and planning resources together in one place'];
export function FitCheck() {
  return <Section className="max-w-5xl" data-id="element-55" data-mp="20q3iueiee04m">
      <div className="grid gap-10 lg:grid-cols-[2fr_3fr] lg:gap-14" data-id="element-56" data-mp="24s8chd8uiwr9">
        <div data-id="element-57" data-mp="24qf49til44h5">
          <h2 className="text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-58" data-mp="24ub8cdwojk3w">Is this guide a good fit?</h2>
          <p className="mt-5 text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-59" data-mp="2eqef5x2h86x6">
            This resource is for Bach Flower learners, practitioners, and therapists who want organized consultation
            references, educational formula studies, case examples, and practical tools in English.
          </p>
        </div>

        <div data-id="element-60" data-mp="p4eovf060sa2">
          <p className="text-sm font-semibold text-stone-900 md:text-base" data-id="element-61" data-mp="p4wpentv1sns">It may be useful if you want to:</p>
          <ul className="mt-4 divide-y divide-stone-200 rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-62" data-mp="kbvawgxkfv4q">
            {fitReasons.map(reason => <li key={reason} className="flex gap-3 p-4 text-sm leading-relaxed text-stone-900 md:text-base" data-id="element-63" data-mp="bd9t4nzx4k50">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-64" data-mp="183938mvpvqpp" />
                {reason}
              </li>)}
          </ul>
          <div className="mt-5 flex gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4" data-id="element-65" data-mp="z2ay219jld5j">
            <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-amber-800" aria-hidden="true" data-id="element-66" data-mp="u37zmzo2i56j" />
            <p className="text-sm leading-relaxed text-stone-700" data-id="element-67" data-mp="3jsjrpm4ln781">
              The guide is not a substitute for formal education, supervision, healthcare qualifications, or local
              professional requirements. It is not designed to diagnose, treat, or manage health conditions.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}